module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view view-permanent",
    class: {
      visible: _vm.isVisible
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e91fbfa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/elements/PermanentView.vue
// module id = 642
// module chunks = 0